<ng-container *ngIf="loaded; then confirmation; else dataInput"></ng-container>

<ng-template #dataInput>
  <form [formGroup]="emailFormGroup" (submit)="onSubmitButtonClick()" class="forgot-form">
    <ion-item lines="none" class="list">
      <ion-button slot="start"
                  (click)="onCloseButtonClick()"
                  color="light"
                  shape="round"
                  class="modal-up-button">
        <i class="far fa-times-circle icon edge-cancel"></i>
        <span>Cancel</span>
      </ion-button>

      <ion-text class="forgot-header">Forgot Password</ion-text>

      <ion-button slot="end"
                  type="submit"
                  [disabled]="emailFormGroup.invalid"
                  shape="round"
                  class="modal-up-button">
        <i class="fas fa-envelope icon edge-submit"></i>
        <span>Send</span>
      </ion-button>
    </ion-item>

    <ion-content>
      <ion-list class="last-list">
        <ion-item lines="none">
          <ion-text class="text-wrap">
            <p>
              Enter the email address used for your account and a password reset link will be sent
              to your email shortly.
              If you do not have access to that email address anymore, please contact
              <a class="support-link" href="mailto:promo.support@sonymusic.com">
                promo.support&#64;sonymusic.com
              </a>
            </p>
          </ion-text>
        </ion-item>

        <ion-item [ngClass]="getClass('emailAddress', 'pattern')">
          <ion-label position="stacked">
            Email<span class="required">*</span>
          </ion-label>
          <ion-input formControlName="emailAddress"
                     name="email"
                     [placeholder]="'Enter Email'"
                     class="input">
          </ion-input>
        </ion-item>
        <div class="rules">
          <strong>Email rules:</strong>
          <ul>
            <li [ngClass]="getClass('emailAddress', 'pattern')">
              Should be valid
            </li>
            <li [ngClass]="getClass('emailAddress', 'required')">
              Required
            </li>
          </ul>
        </div>

        <ion-item [ngClass]="getClass('confirmEmailAddress', 'emailCompare')">
          <ion-label position="stacked">
            Confirm Email<span class="required">*</span>
          </ion-label>
          <ion-input formControlName="confirmEmailAddress"
                     type="email"
                     name="reEmail"
                     [placeholder]="'Re-Enter Email'"
                     class="input">
          </ion-input>
        </ion-item>
        <div class="rules">
          <strong>Confirm Email rules:</strong>
          <ul>
            <li [ngClass]="getClass('confirmEmailAddress', 'emailCompare')">
              Must re-type email to ensure correctness
            </li>
            <li [ngClass]="getClass('confirmEmailAddress', 'required')">
              Required
            </li>
          </ul>
        </div>
      </ion-list>
    </ion-content>
  </form>
</ng-template>

<ng-template #confirmation>
  <div class="confirmation">
    <ion-list>
      <ion-item lines="none">
        <ion-button slot="start" (click)="onCloseButtonClick()"
                    color="light"
                    shape="round"
                    class="modal-up-button">
          <i class="far fa-times-circle icon"></i>
          <span>Close</span>
        </ion-button>
        <ion-text class="forgot-header">Forgot Password</ion-text>
      </ion-item>
    </ion-list>

    <ion-list>
      <ion-item lines="none">
        <strong>Submitted!</strong>
      </ion-item>
      <ion-item text-justify lines="none">
        Your request to reset your password has been submitted. You will be receiving an e-mail
        shortly with instructions.
      </ion-item>
    </ion-list>
  </div>
</ng-template>
